<div class="avatar" [ngClass]="initials ? 'has-initials': ''" [ngStyle]="styles">
    {{ initials }}
</div>